import { getStorageData, saveStorageData } from '../../../../utils/localStorage/localStorage';
import { SESSION_STORAGE } from '../../../../utils/localStorage/localStorageConstants';

const { categoryId } = window.inlinePlp || {};

export const getTemplateName = catId => {
  return catId && catId !== '$' ? 'category' : 'search';
};

export const mapAdvancedCommerceFacets = fullApiResponse => {
  const template = getTemplateName(categoryId);
  const acFacets = fullApiResponse?.elements?.[template]?.products?.facets;
  const header = fullApiResponse?.header;

  if (!Array.isArray(acFacets) || !header) {
    return [];
  }

  const currencySymbol =
    new Intl.NumberFormat(header.language_culture, { style: 'currency', currency: header.currency })
      .formatToParts(1)
      .find(part => part.type === 'currency')?.value || '$';

  const sizeGroupConfig = {
    'search.result.facet.title.size.F': id => id.startsWith('size_f'),
    'search.result.facet.title.size.M': id => id.startsWith('size_m'),
    'search.result.facet.title.size.K': id => id.startsWith('size_k'),
    'search.result.facet.title.size.KA': id => id.startsWith('size_ka'),
    'search.result.facet.title.size.0': id => id.startsWith('size_0'),
    'search.result.facet.title.size.S': id => id.startsWith('size_s'),
  };

  const facetIdCorrectionMap = {
    colorgroup: 'colorGroup',
    productfeatures: 'productFeatures',
    technologygroup: 'technologyGroup',
    family: 'family',
    silhouette: 'silhouette',
  };

  return acFacets.map(facet => {
    if (facet.id === 'size' && Array.isArray(facet.items)) {
      const values = facet.items
        .filter(item => item.count > 0)
        .map(item => {
          let groupTitle = 'Other Sizes';
          // eslint-disable-next-line no-restricted-syntax
          for (const [title, condition] of Object.entries(sizeGroupConfig)) {
            if (condition(item.id)) {
              groupTitle = title;
              break;
            }
          }
          return {
            id: item.id.toUpperCase().replace('_', '_'),
            name: item.titles?.default || '',
            uid: `size:${item.id.toUpperCase().replace('_', '_')}`,
            count: item.count,
            selected: item.selected || false,
            query: { url: item.url },
            facet: 'size',
            title: groupTitle,
            facetImage: `//i8.amplience.net/i/fitflop/facet-size-${item.id.toLowerCase()}?fmt=auto&qlt=default`,
          };
        });

      return {
        id: facet.id,
        name: facet.titles?.default || 'Size',
        nameEn: 'Size',
        category: false,
        priority: 2147483646,
        multiselect: false,
        values,
      };
    }

    const correctedFacetId = facetIdCorrectionMap[facet.id] || facet.id;
    const name = facet.titles?.default || correctedFacetId;
    const idsWithoutPrefix = ['price', 'category'];
    const finalId = idsWithoutPrefix.includes(facet.id) ? facet.id : `@${correctedFacetId}`;

    let values = [];

    if (Array.isArray(facet.items)) {
      values = facet.items
        .filter(item => item.count > 0)
        .map(item => {
          const itemName = item.titles?.default || item.name || item.id;
          const itemUid = `${finalId}:${item.id}`;
          const facetImageName = facetIdCorrectionMap[facet.id] || facet.id;
          const facetImage = `//i8.amplience.net/i/fitflop/facet-${facetImageName.toLowerCase()}-${item.id.toLowerCase()}?fmt=auto&qlt=default`;

          return {
            id: item.id,
            name: itemName,
            uid: itemUid,
            count: item.count,
            selected: item.selected,
            query: { url: item.url },
            facet: finalId,
            title: '',
            facetImage,
          };
        });
    } else if (Array.isArray(facet.ranges)) {
      values = facet.ranges
        .filter(item => item.count > 0)
        .map(item => {
          const fromPrice = Math.floor(item.from);
          let rangeName;
          if (item.to === null) {
            rangeName = `${currencySymbol}${fromPrice}+`;
          } else {
            const toPrice = Math.floor(item.to);
            rangeName = `${currencySymbol}${fromPrice} - ${currencySymbol}${toPrice}`;
          }
          const itemUid = `${finalId}:${rangeName}`;

          return {
            id: rangeName,
            name: rangeName,
            uid: itemUid,
            count: item.count,
            selected: item.selected,
            query: { url: item.url },
            facet: finalId,
            title: '',
            facetImage: null,
          };
        });
    }

    return {
      id: finalId,
      name,
      nameEn: name,
      category: facet.field_type === 'category',
      multiselect: facet.select_type === 'multiple',
      priority: 0,
      values,
    };
  });
};

export const getSessionId = () => {
  const storageKey = 'sessionId';

  let sessionId = getStorageData(storageKey, SESSION_STORAGE);

  if (!sessionId) {
    sessionId = crypto.randomUUID();
    saveStorageData(storageKey, sessionId, SESSION_STORAGE);
  }

  return sessionId;
};

export const getCleanFilters = (itemsPerFacet = {}) => {
  const { query, referrer, ...cleanFilters } = itemsPerFacet;
  return cleanFilters;
};
